import script from "./CodeTextareaSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeTextareaSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./CodeTextareaSwitch.vue?vue&type=style&index=0&id=980d7be2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-980d7be2"]])

export default __exports__